import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import type { inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '../../../api/src/trpc/root';

/**
 * Type-safe tRPC client. The router type is imported across the workspace —
 * no codegen, no sync drift. Cookies are forwarded via `credentials: 'include'`
 * so the same session that authenticates REST also authenticates tRPC.
 */
export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      fetch(url, options) {
        return fetch(url, { ...options, credentials: 'include' });
      },
    }),
  ],
});

/**
 * Server response types, inferred from the router. Prefer these over
 * hand-written mirrors of a DTO — a hand-written type silently drifts, and a
 * narrower one makes cache writes fail to typecheck.
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;

/** One row of an open chat thread, exactly as `chat.messages` returns it. */
export type ThreadMessage = RouterOutputs['chat']['messages']['items'][number];
